import { render, staticRenderFns } from "./orderPayFailed.vue?vue&type=template&id=bb8603a8&"
import script from "./orderPayFailed.vue?vue&type=script&lang=js&"
export * from "./orderPayFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports